module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.project.type != 'homepage') ? _c('div', {
    staticClass: "project-container",
    style: ({
      height: _vm.windowHeight + 'px'
    }),
    attrs: {
      "id": _vm.project.id
    }
  }, [_c('div', {
    staticClass: "project-slide-track"
  }, _vm._l((_vm.project.images), function(image, imageIndex) {
    return _c('project-image', {
      ref: "images",
      refInFor: true,
      attrs: {
        "image": image,
        "projectIndex": _vm.index,
        "project": _vm.project,
        "imageIndex": imageIndex,
        "currentSlide": _vm.currentSlide,
        "showInfo": _vm.showInfoFlag
      },
      on: {
        "ready": _vm.onIsReady,
        "animation": _vm.onAnimation
      }
    })
  }), 1), _vm._v(" "), (_vm.mobileProjectInfo) ? _c('div', {
    staticClass: "mobile-project-info-overlay",
    style: ({
      width: _vm.layout.width + 'px',
      height: _vm.layout.height + 'px'
    })
  }, [_c('a', {
    staticClass: "icon close mobile",
    on: {
      "click": _vm.hideMobileProjectInfo
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/HMJ-Close_mobil.svg",
      "alt": "close icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    style: ({
      marginLeft: _vm.layout.offsetLeft + 'px',
      marginTop: _vm.layout.offsetTop + 'px'
    })
  }, [_c('div', {
    staticClass: "content-cell"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.project.title[_vm.lang]))]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.project.text[_vm.lang].description) + "\n                ")])])])]) : _vm._e(), _vm._v(" "), (_vm.layout.type == 'large') ? _c('div', {
    staticClass: "project-info-line",
    on: {
      "click": _vm.showInfo
    }
  }, [_c('span', {
    staticClass: "project-info title"
  }, [_vm._v(_vm._s(_vm.project.title[_vm.lang]))]), _vm._v(" "), _c('span', {
    staticClass: "project-info page"
  }, [_vm._v(_vm._s(_vm.currentSlide + 1) + "/" + _vm._s(_vm.totalImages))]), _vm._v(" "), (_vm.ready) ? _c('a', {
    staticClass: "project-info info-trigger"
  }, [_vm._v("Info")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.layout.type != 'large' && _vm.layout.orientation == 'portrait') ? _c('div', {
    staticClass: "project-info-mobile"
  }, [(_vm.layout.type == 'medium' && _vm.layout.orientation == 'portrait') ? _c('span', {
    staticClass: "project-info title"
  }, [_vm._v(_vm._s(_vm.project.title[_vm.lang]))]) : _vm._e(), _vm._v(" "), (_vm.layout.type == 'medium' && _vm.layout.orientation == 'portrait') ? _c('span', {
    staticClass: "project-info page"
  }, [_vm._v(_vm._s(_vm.currentSlide + 1) + "/" + _vm._s(_vm.totalImages))]) : _vm._e(), _vm._v(" "), (_vm.layout.orientation == 'portrait') ? _c('a', {
    staticClass: "project-info info-trigger portrait",
    on: {
      "click": _vm.showMobileProjectInfo
    }
  }, [_vm._v("Info")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.layout.orientation == 'landscape' && _vm.layout.type != 'large' && _vm.currentId == _vm.project.id) ? _c('a', {
    staticClass: "project-info-mobile-landscape ",
    on: {
      "click": _vm.showMobileProjectInfo
    }
  }, [(_vm.layout.mobileNavigation !== true) ? _c('span', [_vm._v("Info")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.project.type == 'homepage') ? _c('div', {
    staticClass: " homepage",
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.windowHeight + 'px',
      width: _vm.windowWidth + 'px'
    }),
    attrs: {
      "id": _vm.project.id
    }
  }, [_c('div', {
    staticClass: "homepage-content",
    class: {
      light: _vm.lightSiteTitle
    },
    staticStyle: {
      "background-image": "url(/static/images/startseite/Highline-Kapuzenturm-2-09-Neu.jpg)",
      "background-repeat": "no-repeat"
    },
    style: ({
      height: _vm.windowHeight - _vm.windowMargin * 2 + 'px',
      width: _vm.windowWidth - _vm.windowMargin * 2 + 'px',
      marginTop: _vm.windowMargin + 'px',
      backgroundImage: 'url(/static/images/startseite/' + _vm.startImage.file + ')',
      backgroundPosition: _vm.startImage.position
    })
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "site-title",
    style: ({
      paddingTop: _vm.windowHeight * 0.3 + 'px'
    })
  }, [_vm._v("Henning Maier-Jantzen "), _c('em', [_vm._v("Photography")])]), _vm._v(" "), _c('div', {
    staticClass: "homepage-arrow",
    style: ({
      width: _vm.windowWidth - _vm.windowMargin * 2 + 'px'
    })
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-info hide-for-small-only hide-for-medium-only"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "mailto:contact@maier-jantzen.de"
    }
  }, [_vm._v("contact@maier-jantzen.de")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "/seite/contact"
    }
  }, [_vm._v("+49 171 19 63 601")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d25c0a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project.vue
// module id = 183
// module chunks = 2